
<div class="row">
  <div class="col-xs-4 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
      <div class="colum_first">
        <p [ngClass]="{'info_texto': tramiteActual.processId===2,'info_texto_dos': tramiteActual.processId===3 }">Tramite ID</p>
          <p>Estado Trámite</p>
          <p>Fecha Trámite</p>
          <p>Tipo de Trámite: <span>{{tramiteActual.process}}</span></p>
      </div>
  </div>




  <div class="col-xs-4 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
      <div class="colum_second">
        <p >{{tramiteActual.filedNumber}}</p>
        <p >{{tramiteActual.status}}</p>
        <p >{{tramiteActual.date | date: 'dd/MM/yyyy hh:mm a'}}</p>
        <button class="btn btn-danger" *ngIf="(this.tramiteActual.processId == 2 || this.tramiteActual.processId == 3) && isOnlyReadTramite==false"  (click)="first()">Cambiar a Primera Vez</button>
        <button class="btn btn-info " *ngIf="(this.tramiteActual.processId == 1 || this.tramiteActual.processId == 3) && isOnlyReadTramite==false" (click)="update()">Cambiar a Modificación</button>
        <button class="btn btn-warning" *ngIf="(this.tramiteActual.processId == 1 || this.tramiteActual.processId == 2) && isOnlyReadTramite==false"  (click)="renove()">Cambiar a Renovación</button>
      </div>

  </div>

</div>
<div class="row">
  <div class="colum_history">
   <button (click)="openmodal(tramiteActual.userId)" data-bs-toggle="modal"  data-bs-target="#tramites-usuario"  class="btn btn-primary  info_size">Trámites del usuario <span class="badge bg-light">{{cantidadTramitesDelUsuario}}</span></button>
  </div>
</div>

            <!-- Modal -->
            <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="tramites-usuario" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-xl">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">Tabla de información</h5>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                          <table class="table" aria-describedby="mydesc">
                              <thead>
                                  <tr>
                                      <th>N° Radicado</th>
                                      <th>Fecha</th>
                                  </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let item of infoTramitesDelUsuario let i = index">
                                  <td>{{item.filedNumber}}</td>
                                  <td>{{item.date | date: 'dd/MM/yyyy hh:mm a'}}</td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                      <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                      </div>
                  </div>
              </div>
          </div>
<div class="row mt-5">
  <div class="d-flex align-items-start">
      <div class="col-xs-4 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
          <div class="colum_nav_title">
              <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Datos Personales</button>
                  <button class="nav-link" id="v-pills-modificacion-tab" data-bs-toggle="pill" data-bs-target="#v-pills-modificacion" type="button" role="tab" aria-controls="v-pills-modificacion" aria-selected="false" *ngIf="isModification==true">Datos adicionales modificación</button>
                  <button class="nav-link" id="v-pills-renovacion-tab" data-bs-toggle="pill" data-bs-target="#v-pills-renovacion" type="button" role="tab" aria-controls="v-pills-renovacion" aria-selected="false" *ngIf="isRenewal==true">Datos adicionales renovación</button>
                  <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" *ngIf="isLegalPerson==false">Datos Laborales</button>
                  <button class="nav-link" id="v-pills-service-tab" data-bs-toggle="pill" data-bs-target="#v-pills-service" type="button" role="tab" aria-controls="v-pills-service" aria-selected="false">Tipos de servicio a prestar</button>
                  <button class="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Documentos Adjuntos</button>
                  <button class="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings" type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">Campos de Acción</button>
                  <button *ngIf="isOnlyReadTramite==false" class="nav-link" id="v-pills-field-tab" data-bs-toggle="pill" data-bs-target="#v-pills-field" type="button" role="tab" aria-controls="v-pills-field" aria-selected="false">Resultado Validación</button>
                  <button *ngIf="isOnlyReadTramite==true" class="nav-link" id="v-pills-audit-tab" data-bs-toggle="pill" data-bs-target="#v-pills-audit" type="button" role="tab" aria-controls="v-pills-audit" aria-selected="false">Seguimiento</button>
              </div>
          </div>
      </div>
      <div class="col-xs-4 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" style="width: 800px;">
          <div class="colum_nav_content">
              <form [formGroup]=" formulario_info">
                <div class="tab-content" id="v-pills-tabContent">
                  <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                      <div class="card">
                          <div class="card-header bg-primary text-white">
                              Datos Personales
                          </div>
                          <div class="card-body">
                              <app-applicant-information > [title]="'personal_info'"></app-applicant-information>
                          </div>
                      </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-modificacion" role="tabpanel" aria-labelledby="v-pills-modificacion-tab">
                    <div class="card">
                      <div class="card-header bg-primary text-white">
                        Datos adicionales modificación
                      </div>
                      <div class="card-body">
                        <app-modification [isPersonaJuridica]="isLegalPerson"></app-modification>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-renovacion" role="tabpanel" aria-labelledby="v-pills-renovacion-tab">
                    <div class="card">
                      <div class="card-header bg-primary text-white">
                        Datos adicionales renovación
                      </div>
                      <div class="card-body">
                        <app-renewal></app-renewal>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab" *ngIf="isLegalPerson==false">
                      <div class="card">
                          <div class="card-header bg-primary text-white">
                              Datos Laborales
                          </div>
                          <div class="card-body">
                            <app-labor-data  [tramiteObject]="tramiteActual" [title]="'laboral_data'"></app-labor-data>
                          </div>
                      </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-service" role="tabpanel" aria-labelledby="v-pills-service-tab">
                    <div class="card">
                        <div class="card-header bg-primary text-white">
                           Tipos de servicio a prestar
                        </div>
                        <div class="card-body">
                          <app-type-service-provide [tramiteObject]="tramiteActual"  [title]="'info_services'"></app-type-service-provide>
                        </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                      <div class="card">
                          <div class="card-header bg-primary text-white">
                              Documentos Adjuntos
                          </div>
                          <div class="card-body">
                          <app-document-user  [title]="'document_data'" [tramiteObject]="tramiteActual" [isLegalPerson]="isLegalPerson" ></app-document-user>
                          </div>
                      </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                      <div class="card">
                          <div class="card-header bg-primary text-white">
                            Campos de Acción
                          </div>
                          <div class="card-body">
                            <app-fields-action  [title]="'profiles_data'" [tramiteObject]="tramiteActual" [isLegalPerson]="isLegalPerson" [onlyReadFieldsActions]="isOnlyReadTramite"></app-fields-action>
                          </div>
                      </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-field" role="tabpanel" aria-labelledby="v-pills-field-tab">
                    <div class="card">
                        <div class="card-header bg-primary text-white">
                          Resultado Validación
                        </div>
                        <div class="card-body">
                          <app-validation-result [tramiteObject]="tramiteActual" [title]="'modal_data'"  [title]="'modal_info'" [isLegalPerson]="isLegalPerson"></app-validation-result>

                          <div *ngIf="isLegalPerson==true">
                            <app-visit-info></app-visit-info>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="v-pills-audit" role="tabpanel" aria-labelledby="v-pills-audit-tab">
                    <div class="card">
                      <div class="card-header bg-primary text-white">
                        Seguimiento
                      </div>
                      <div class="card-body">
                        <app-audit [tramiteObject]="tramiteActual"></app-audit>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12" style="margin: 5% 0 5% 0; text-align: right">
                  <button type="button" class="btn-govco fill-btn-govco" *ngIf="isOnlyReadTramite==false" (click)="preliminar()" [disabled]="sending" style="margin-right: 10px;">Preliminar</button>
                  <button type="button" class="btn-govco fill-btn-govco" *ngIf="isOnlyReadTramite==false" (click)="popUpConfirmacionGuardar()" [disabled]="sending" >Guardar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</div>

